import classes from "../classes";
import ellide from "../ellide";
import EntrantPicksPopup from "./entrant-picks-popup";
import pure from "./higher-order/pure";
import React from "react";
import { TooltipBlock } from "./tooltip";
import TowelIcon from "./towel-icon";
import { FormattedScore } from "./formatted-currency";

export default pure((props) => {
  var { name } = props;
  if (name) {
    return <NamedTowel {...props} />;
  } else {
    return <BasicTowel {...props} />;
  }
});

function BasicTowel({ highlight = true, lane, score, tooltip }) {
  var scoreElement = (
    <span>
      {score}
    </span>
  );
  if (typeof score === "number") {
    scoreElement = <FormattedScore value={score} />;
  }
  return (
    <div>
      <TooltipBlock text={tooltip}>
        <TowelIcon lane={lane} />

        <div className={classes({
          "game-table_score": true,
          "game-table_score--has-points": score > 0.0 && highlight
        })}>
          {scoreElement}
        </div>
      </TooltipBlock>
    </div>
  );
}

export function SurvivorTowel({ lane, score, tooltip }) {
  return (
    <div>
      <TooltipBlock text={tooltip}>
        <div className={classes({
          "dw-warning5": lane === undefined,
          "dw--1-25x": lane === undefined,
          "color--is-medium-gray": lane === undefined,
          "towel": lane !== undefined,
          ["towel--" + lane]: lane !== undefined
        })} />

        <div className={classes({
          "game-table_score": true,
          "game-table_score--has-points": score === "Win",
          "color--is-medium-gray": score === "––",
          "color--is-red": score === "Loss"
        })}>
          {score}
        </div>
      </TooltipBlock>
    </div>
  );
}

export var NamedTowel = pure(function NamedTowel({ lane, position, raceEntrant, score, tickets, users }) {
  return (
    <EntrantPicksPopup position={position} raceEntrant={raceEntrant} tickets={tickets} users={users}>
      <dl className="game-table_result">
        <dt>
          <TowelIcon lane={lane} small />
        </dt>

        <dd>
          <div className={classes({ "game-table_score": true })}>
            <FormattedScore value={score} />
          </div>
        </dd>
      </dl>

      <div className="game-table_horse-name" style={{ textOverflow: "ellipsis" }}>
        {ellide(raceEntrant.get("horse_name"), 8)}
      </div>
    </EntrantPicksPopup>
  );
});
